var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminalMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TerminalMarker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1717922,11.400052 C26.2941819,1.27766235 42.7058181,1.27766235 52.8282078,11.400052 C62.9505974,21.5224416 62.9505974,37.9340779 52.8282078,48.0564675 L36.5364675,64.3482078 C35.4117576,65.4729177 33.5882424,65.4729177 32.4635325,64.3482078 L16.1717922,48.0564675 C6.15062649,38.0353018 6.05041483,21.8500454 15.8711573,11.7055979 L16.1717922,11.400052 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.204088438 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TerminalMarker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF6366",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.5353145,10.6929452 C64.0482285,21.2058591 64.0482285,38.2506604 53.5353145,48.7635743 L37.2435743,65.0553145 C35.7283401,66.5705488 33.2716599,66.5705488 31.7564257,65.0553145 L15.4646855,48.7635743 C5.0690446,38.3679335 4.94079017,21.5585351 15.1583453,11.0042427 L15.4589803,10.6986968 C25.9775994,0.180031278 43.0224006,0.180031278 53.5353145,10.6929452 Z M52.8282078,11.400052 C42.7058181,1.27766235 26.2941819,1.27766235 16.1717922,11.400052 L15.8711573,11.7055979 C6.05041483,21.8500454 6.15062649,38.0353018 16.1717922,48.0564675 L32.4635325,64.3482078 C33.5882424,65.4729177 35.4117576,65.4729177 36.5364675,64.3482078 L52.8282078,48.0564675 C62.9505974,37.9340779 62.9505974,21.5224416 52.8282078,11.400052 Z",
    id: "PinOutline",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Iconfield",
    fill: "#FFFFFF",
    cx: 34.5,
    cy: 29.7282598,
    r: 19.0771654
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.295,19.2052765 C31.295,17.4379653 32.7276888,16.0052765 34.495,16.0052765 C36.2623112,16.0052765 37.695,17.4379653 37.695,19.2052765 C37.695,20.9725877 36.2623112,22.4052765 34.495,22.4052765 C32.7276888,22.4052765 31.295,20.9725877 31.295,19.2052765 Z M32.895,24.0052765 L36.095,24.0052765 C37.86,24.0052765 39.295,25.4402765 39.295,27.2052765 L39.295,31.2052765 L37.605,31.2052765 L36.895,37.6052765 L32.095,37.6052765 L31.385,31.2052765 L29.695,31.2052765 L29.695,27.2052765 C29.695,25.4402765 31.13,24.0052765 32.895,24.0052765 Z M24.46,36.9652765 C24.28,37.0852765 24.28,37.3252765 24.46,37.4452765 C24.9,37.7302765 25.615,38.0352765 26.61,38.3102765 C28.58,38.8552765 31.37,39.2052765 34.495,39.2052765 C37.62,39.2052765 40.41,38.8552765 42.38,38.3102765 C43.375,38.0352765 44.09,37.7302765 44.53,37.4452765 C44.71,37.3252765 44.71,37.0852765 44.53,36.9652765 C44.425,36.8952765 44.29,36.8202765 44.135,36.7402765 C43.37,36.3552765 42.195,35.9952765 40.685,35.7152765 L41.115,33.3552765 C42.735,33.6502765 44.16,34.0652765 45.215,34.5952765 C45.74,34.8602765 46.23,35.1802765 46.605,35.5752765 C46.985,35.9802765 47.305,36.5302765 47.305,37.2052765 C47.305,38.2752765 46.53,39.0102765 45.85,39.4552765 C45.115,39.9352765 44.135,40.3202765 43.03,40.6252765 C40.785,41.2402765 37.775,41.6052765 34.495,41.6052765 C31.215,41.6052765 28.205,41.2402765 25.975,40.6252765 C24.87,40.3202765 23.885,39.9352765 23.155,39.4552765 C22.47,39.0102765 21.695,38.2752765 21.695,37.2052765 C21.695,36.5302765 22.015,35.9802765 22.395,35.5752765 C22.77,35.1802765 23.26,34.8602765 23.785,34.5952765 C24.835,34.0652765 26.26,33.6502765 27.885,33.3552765 L28.315,35.7152765 C26.805,35.9902765 25.63,36.3552765 24.865,36.7402765 C24.705,36.8202765 24.575,36.8952765 24.47,36.9652765 L24.46,36.9652765 Z",
    id: "Icon",
    fill: "#FF6366",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalMarker);
export default __webpack_public_path__ + "static/media/TerminalMarker.2120e478b21f659113cff9d03ff140b6.svg";
export { ForwardRef as ReactComponent };